var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBankingLOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1666 19.6667H4.66663V34.8334H11.1666V19.6667Z",
    fill: "#F25C3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 19.6667H18.75V34.8334H25.25V19.6667Z",
    fill: "#F25C3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6666 39.1667H0.333313V45.6667H43.6666V39.1667Z",
    fill: "#F25C3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3333 19.6667H32.8333V34.8334H39.3333V19.6667Z",
    fill: "#F25C3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 0.166748L0.333313 11.0001V15.3334H43.6666V11.0001L22 0.166748Z",
    fill: "#F25C3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBankingLOrange);
export default __webpack_public_path__ + "static/media/icon-banking-l-orange.94ffd74877458f82239729fe9428a580.svg";
export { ForwardRef as ReactComponent };